import { render } from "./LiquidityModal.vue?vue&type=template&id=04b5f74b"
import script from "./LiquidityModal.vue?vue&type=script&lang=js"
export * from "./LiquidityModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LiquidityModal.vue?vue&type=style&index=0&id=04b5f74b&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__